module.exports = __webpack_public_path__ + "static/media/09_360.9ef7ca30.jpeg";